import { __ } from '../i18n/vsme';
import type { DiligencePackSuggestion } from '../utils/missionStartApi';

export type DiligencePackSelectCardProps = {
  pack: DiligencePackSuggestion;
  selected: boolean;
  onToggle: () => void;
  disabled?: boolean;
};

const DiligencePackSelectCard = ({ pack, selected, onToggle, disabled = false }: DiligencePackSelectCardProps) => {
  const targetLabel = pack.target_mode === 'all' ? __('Tous les dossiers') : __('Dossiers sélectionnés');
  const metaItems = [
    targetLabel,
    ...(typeof pack.item_count === 'number' ? [`${pack.item_count} ${__('diligences')}`] : []),
  ];

  return (
    <div className="container-style pack-card">
      <div className="pack-card__actions">
        <span className={`pack-card__mode pack-card__mode--${pack.target_mode}`}>
          {targetLabel}
        </span>
        <input
          type="checkbox"
          checked={selected || pack.locked}
          disabled={disabled || pack.locked}
          aria-label={pack.name}
          onChange={onToggle}
        />
      </div>
      <p className="pack-card__name">{pack.name}</p>
      <ul className="pack-card__items">
        {metaItems.map((label) => (
          <li key={`${pack.pack_id}-${label}`}>{label}</li>
        ))}
      </ul>
    </div>
  );
};

export default DiligencePackSelectCard;
